import { Typography } from "@mui/material";
import { Dayjs } from "dayjs";
import { useSelector } from "react-redux";
import dayjs from "../../util/dayjs";
import DateSelectDialog from "../../components/GreenCity/DateSelectDialog";
import { useAppDispatch } from "../../redux/store";
import { setEventItem } from "../../redux/Reducers/createPostReducer";
import Section from "./Section";
import { T } from "react-translator-component";
import { useEffect } from "react";

interface Props {
  baseDate: Dayjs,
}

export default function EventTerm({ baseDate }: Props) {
  const dispatch = useAppDispatch();

  const postEvent = useSelector((state: any) => state.createPost.values.event);
  const startDate = postEvent.startDate;
  const endDate = postEvent.endDate;
  const errors = useSelector((state: any) => state.createPost.errors.event);

  useEffect(() => {
    if (!startDate) return
    startDate?.isAfter(endDate) &&
      dispatch(setEventItem({key: 'endDate', value: startDate}))
  },[startDate])

  return (
    <Section
      title={T("event_term")}
      body={
        <>
          <Typography sx={ styles.evebtDateLabel } >
            {`${T("start_date")}${T("required")}`}
          </Typography>
          <DateSelectDialog
            inputedDate={dayjs(startDate)}
            minDate={baseDate}
            onChange={(date) => dispatch(setEventItem({key: 'startDate', value: date}))}
          />

          <Typography sx={ styles.evebtDateLabel } >
            {`${T("end_date")}${T("end_date_description")}`}
          </Typography>
          <DateSelectDialog
            inputedDate={dayjs(endDate)}
            minDate={dayjs(startDate)}
            onChange={(date) => dispatch(setEventItem({key: 'endDate', value: date}))}
            errorMessage={errors.endDate}
          />
        </>
      }
    />
  )
}

const styles = {
  evebtDateLabel: {
    paddingTop: "30px",
    textAlign: "left",
    fontSize: "15px",
  }
}
